enum OverviewAppPaths {
  Home = '/',
}

export default OverviewAppPaths;
